import routes from '@/router/routes.js';
import VueRouter from 'vue-router';
export default new VueRouter({
  routes
})